"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TecnicoEnAiresAcondicionadosResumen() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="tecnico-en-aires-acondicionados-resumen" className="relative overflow-hidden bg-foreground py-20 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-sidebar-foreground)_0%,transparent_70%)] opacity-60 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-[4/3] lg:aspect-square max-w-2xl mx-auto transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative w-full h-full rounded-3xl overflow-hidden shadow-2xl shadow-black/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/technician_measuring_refrigerant.png" alt="Técnico midiendo niveles de refrigerante" className="w-full h-full object-cover object-center" />
              {}
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay pointer-events-none" />
            </div>

            {}
            <div className="absolute -right-8 top-1/4 w-24 h-1/2 bg-sidebar-foreground/40 backdrop-blur-md rounded-l-[2rem] z-10 hidden lg:block border-l border-y border-white/5 shadow-xl" />
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-sans font-extrabold text-secondary leading-tight tracking-tight mb-6">
              Técnico en Aires Acondicionados
            </h2>
            
            <p className="text-lg sm:text-xl font-sans text-background/90 leading-relaxed mb-10 max-w-xl">
              Fórmate como un profesional altamente capacitado en la instalación, mantenimiento y reparación de sistemas de climatización. Domina las herramientas del sector y asegura tu futuro en un mercado con demanda constante y creciente.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild variant="secondary" size="lg" className="rounded-[24px] h-14 px-8 text-lg font-bold shadow-[0_0_20px_rgba(var(--color-secondary),0.4)] hover:shadow-[0_0_30px_rgba(var(--color-secondary),0.6)] transition-shadow duration-300">
                <Link to="https://wa.me/59896344395">
                  Chatea por WhatsApp
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}